
import { Component } from '@angular/core';

import { Observable, Subscription } from 'rxjs';
import { Store } from '@ngrx/store';

import {
  BrokerService,
  DirectorConnectionService,
  DirectorConnectionState,
  MonitoredHttpState,
  CONNECTION_STATUS
} from '@c4/core';

import { AboutState, AboutService, ABOUT_ACTIONS } from './about.service';

@Component({
  selector: 'cw-about',
  templateUrl: './about.component.html'
})
export class AboutComponent {

  private about: Observable<AboutState>;

  private memoryMB: Observable<number>;
  private memoryPercent: Observable<number>;

  private cpu: Observable<number>;

  private uptime: Observable<{
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  }>;

  private statsObs: Observable<any>;
  private statsSub: Subscription;

  private directorReady: Observable<boolean>;
  private directorState: Observable<DirectorConnectionState>;

  private _connection: Observable<CONNECTION_STATUS>;
  private _rebooting: Observable<boolean>;

  constructor(
    private service: AboutService,
    private store: Store<{
      about: AboutState,
      directorConnection: DirectorConnectionState,
      monitoredHttpState: MonitoredHttpState
    }>,
    private broker: BrokerService,
    private director: DirectorConnectionService
  ) {
    this.about = this.store.select(s => s.about);

    let stats = this.about.filter(a => !!a && !!a.stats).map(a => a.stats);

    this.memoryMB = stats.map(stats => {
      return Math.round(stats.memUsed / 1000);
    });

    this.memoryPercent = stats.map(stats => {
      return Math.round(stats.memUsed / stats.memTotal * 100)
    });

    this.cpu = stats.map(s => s.cpuTotal);

    this.uptime = stats.map(s => {
      let elapsed = Date.parse(s.currentTime) - Date.parse(s.bootTime);
      let days = Math.floor(elapsed / (1000 * 60 * 60 * 24));
      let hours = Math.floor(elapsed / (1000 * 60 * 60)) - (days * 24);
      let minutes = Math.floor(elapsed / (1000 * 60)) - (days * 24 * 60) - (hours * 60);
      let seconds = Math.floor(elapsed / 1000) - (days * 24 * 60 * 60) - (hours * 60 * 60) - (minutes * 60);

      return {
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds
      };
    });

    this.statsObs = this.broker.getObservable({
      path: '/api/v1/stats',
      queryString: {
        rate: 5
      }
    });

    this.directorState = this.store.select(s => s.directorConnection);

    this.directorReady = this.directorState
      .filter(d => !!d)
      .map(d => d.director == 'connected' || d.director == 'disabled');

    this._connection = this.store.select(s => s.monitoredHttpState.connectionStatus).distinctUntilChanged();

    this._rebooting = Observable.combineLatest(
      this._connection,
      this.store.select(s => s.monitoredHttpState.rebootRequested).distinctUntilChanged(),
      (connection, rebootRequested) => connection == CONNECTION_STATUS.DISCONNECTED && rebootRequested
    );

    this._connection
      .filter(c => c == CONNECTION_STATUS.CONNECTED)

      // Why do I need to introduce this delay
      // upon reconnecting? It is a mystery, but
      // broker won't return anything if I don't
      .debounce(() => {
        let interval = (!!this.statsSub) ? 5000 : 0;
        return Observable.timer(interval);
      })
      .subscribe(connected => {
        this.statsSub = this.statsObs.subscribe(stats => {
          this.store.dispatch({
            type: ABOUT_ACTIONS.SET_STATS,
            payload: stats
          });
        })
      });
  }

  ngOnDestroy() {
    try {
      this.statsSub.unsubscribe();
    } catch (e) {
      console.warn('WARNING: stats subscription did not end gracefully.', e);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/about/about.component.ts